import { generateAboutURL } from "../../../src/services/url";
import {
  CURRENCY,
  LOGO_URL,
  ACCCOUNT_FEES,
  EVENT_HANDLERS,
  LOCATION,
} from "../../constants";

import {
  getInstallment,
  getTitles,
  isPromotionLengthValid,
  createQueryString,
  reviseWidgetSettings
} from "./utils";

export const Standard = ({
  merchantId = "",
  currency = CURRENCY.AUD,
  containerClass = "",
  price,
  paymentOption,
  promotionMonths,
  productName,
  allowPriceBreakdown,
  defaultWidget,
  minAmount,
}) => {
  const logoURL = LOGO_URL[currency];
  const accountFees = ACCCOUNT_FEES[currency];
  const { amount, length, amnt } = getInstallment(price, promotionMonths);

  let revised = reviseWidgetSettings({
    paymentOption,
    minAmount,
    price,
    allowPriceBreakdown,
    defaultWidget
  });

  allowPriceBreakdown = revised.allowPriceBreakdown;
  defaultWidget = revised.defaultWidget;
  
  const aboutURL = generateAboutURL(
    merchantId,
    currency,
    createQueryString(
      paymentOption,
      price,
      promotionMonths,
      allowPriceBreakdown,
      productName,
      LOCATION.WIDGET
    )
  );

  const { FALLBACK_TITLE, LEGACY_TITLE, PRICE_BREAKDOWN_TITLE } = getTitles({
    length,
    amount,
    amnt,
    price,
    currency,
    aboutURL,
    defaultWidget,
  });

  const title = allowPriceBreakdown
    ? PRICE_BREAKDOWN_TITLE
    : isPromotionLengthValid(length)
      ? FALLBACK_TITLE
      : LEGACY_TITLE;

  return `
  <!-- Latitude Interest Free Snippet - Start -->
  <div
    style="font-size: 14px; margin: 10px 0px; font-weight:450; display: flex; flex-wrap: wrap; align-items: center; max-width:420px"
    class="${containerClass}">
     <img
        style="${currency === "AUD" ? `height:16px;` : `height:22px;`} ${allowPriceBreakdown ? `margin: 0px 12px 12px 0;` : `margin: 0 12px;`
    }"
        src="${logoURL}"
        alt="logo-${currency}"
      />
      ${title}
     
  ${!allowPriceBreakdown
      ? `
      <span
        style="white-space:nowrap; margin-left: 6px;" 
      >
        <a
          id="lat-find-out"
          style="text-decoration:underline; cursor:pointer; color:inherit;"
          target="_blank"
          onclick="${EVENT_HANDLERS.LEARN_MORE_CLICK}('${aboutURL}')"
        >
         Learn more
        </a>
      </span>
      `
      : ""
    }
  
  </div>
  <!-- Latitude Interest Free Snippet - End -->
  `;
};